/* eslint-disable react-refresh/only-export-components */
import { useQuery } from '@tanstack/react-query'
import { createContext, useContext, useEffect, useState } from 'react'

import { Member } from '@ui/interfaces'
import { useAuth } from '@ui/providers/AuthProvider'
import { orgService } from '@ui/services'
import { Team } from '@ui/services'

interface SettingsContextType {
  currentMember: Member

  orgMembers: Member[]
  setOrgMembers: (members: Member[]) => void
  selectedTeam: Team | null
  setSelectedTeam: (team: Team | null) => void
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined)

export const SettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuth()
  const { currentOrganization, currentMember } = auth

  const [orgMembers, setOrgMembers] = useState<Member[]>([])
  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null)

  const { data: membersData } = useQuery({
    queryKey: ['members'],
    queryFn: () => orgService.fetchMembers(currentOrganization?.id.toString() ?? ''),
    enabled: !!currentOrganization,
  })

  useEffect(() => {
    setOrgMembers(membersData ?? [])
  }, [membersData])

  return (
    <SettingsContext.Provider
      value={{ currentMember: currentMember!, orgMembers, setOrgMembers, selectedTeam, setSelectedTeam }}>
      {children}
    </SettingsContext.Provider>
  )
}

export const useSettings = () => {
  const context = useContext(SettingsContext)
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider')
  }
  return context
}
